import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  font-size: 16px;
  padding: 16px;

  div {
    display: flex;
  }

  p {
    font-weight: 600;
  }

  span {
    font-size: 400;
    color: #7c8db5;
  }

  button {
    border: 2px solid gray;
    border-radius: 8px;
    height: 30px;
    padding: 0px 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: gray;
    font-size: 12px;
    background-color: transparent;

    animation: bounce 0.5s;
    animation-direction: alternate;
    animation-timing-function: cubic-bezier(.5, 0.05, 1, .5);
    animation-iteration-count: infinite;

    @keyframes bounce {
      from {
        transform: translate3d(0, 0, 0);
      }
      to {
        transform: translate3d(0, 10px, 0);
      }
    }
  }

  button:disabled {
    color: #7c8db5;
  }
`;
